﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListBestellung extends GuiListGeneric {
    constructor() {
        super("Bestellung");
    }
}
